import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { Condition, conditionApi, ConditionType } from "@/api/misc";

export interface ConditionState {
  deliveryConditions: Condition[];
  paymentConditions: Condition[];
}

const conditionModule: Module<ConditionState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      deliveryConditions: [] as Condition[],
      paymentConditions: [] as Condition[],
    } as ConditionState),
  mutations: {
    setDeliveryConditions(
      state: ConditionState,
      deliveryConditions: Condition[]
    ): void {
      state.deliveryConditions = deliveryConditions;
    },
    setPaymentConditions(
      state: ConditionState,
      paymentConditions: Condition[]
    ): void {
      state.paymentConditions = paymentConditions;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<ConditionState, RootState>
    ): Promise<void> {
      if (
        !context.state.deliveryConditions ||
        context.state.deliveryConditions.length === 0
      ) {
        context.commit(
          "setDeliveryConditions",
          await conditionApi.listDeliveryCondition()
        );
      }
      if (
        !context.state.paymentConditions ||
        context.state.paymentConditions.length === 0
      ) {
        context.commit(
          "setPaymentConditions",
          await conditionApi.listPaymentCondition()
        );
      }
    },
    async addCondition(
      context: ActionContext<ConditionState, RootState>,
      condition: Condition
    ): Promise<void> {
      await conditionApi.addCondition(condition);
      if (condition.type === ConditionType.DELIVERY) {
        context.commit(
          "setDeliveryConditions",
          await conditionApi.listDeliveryCondition()
        );
      }
      if (condition.type === ConditionType.PAYMENT) {
        context.commit(
          "setPaymentConditions",
          await conditionApi.listPaymentCondition()
        );
      }
    },
    async editCondition(
      context: ActionContext<ConditionState, RootState>,
      condition: Condition
    ): Promise<void> {
      if (condition.id) {
        await conditionApi.editCondition(condition);
        if (condition.type === ConditionType.DELIVERY) {
          context.commit(
            "setDeliveryConditions",
            await conditionApi.listDeliveryCondition()
          );
        }
        if (condition.type === ConditionType.PAYMENT) {
          context.commit(
            "setPaymentConditions",
            await conditionApi.listPaymentCondition()
          );
        }
      }
    },
    async removeCondition(
      context: ActionContext<ConditionState, RootState>,
      condition: Condition
    ): Promise<void> {
      if (condition.id) {
        await conditionApi.deleteCondition(condition);
        if (condition.type === ConditionType.DELIVERY) {
          context.commit(
            "setDeliveryConditions",
            await conditionApi.listDeliveryCondition()
          );
        }
        if (condition.type === ConditionType.PAYMENT) {
          context.commit(
            "setPaymentConditions",
            await conditionApi.listPaymentCondition()
          );
        }
      }
    },
  },
};

export default conditionModule;
